const transLookup = {
  sale: 'Sale',
  lease: 'Lease',
  incexp: 'Income & Expense',
  const: 'Construction'
}

/**
 * Get transaction readable name
 * @param  {String} trans       transaction key
 * @return {String}             transaction readable name
 */
export default function getTransactionName (trans) {
  return transLookup[trans.toLowerCase()] || ''
}



// WEBPACK FOOTER //
// ./modules/utils/getTransactionName.js